import { createFileRoute } from '@tanstack/react-router'

import { IOSInstallPage } from '~/boundedContext/settings/pages/ios-install'

export const Route = createFileRoute('/_main-layout/settings/ios-install')({
  component: IOSInstallPage,
})
